import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import './assets/site.css'

Vue.config.productionTip = false

// https://github.com/vuejs/vuex-router-sync
sync(store, router)
// metatags
Vue.use(VueMeta)

//  Google Analytics
const trackingId = 'UA-23235561-4'
Vue.use(VueAnalytics, {
  id: trackingId,
  linkers: [
    'fsi.taxjustice.no',
    'fsi2.taxjustice.no',
    'fsi.stage.kartoteket.as',
    'fsi2018.kartoteket.as',
    'index.taxjustice.net'
  ],
  router,
  debug: {
    enabled: false,
    trace: false,
    sendHitTask: true
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
